module.exports = __webpack_public_path__ + "img/022532e.png";